<template>
	<div class="page-box" @click="refresh">
		<div class="box">
			<img src="@/images/common/error.png" />
			<p>哎呀，出现了点意外，请点击屏幕或关闭浏览器后重新打开~</p>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				
			}
		},
		methods:{
			refresh(){
				window.location.reload()
			}
		}
	}
</script>

<style scoped lang="scss">
	.page-box{
		width: 100%;
		height: 100vh;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
		background: #fff;
		.box {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			img {
				width: 350px;
				margin: 0 auto;
			}
			p {
				font-size: 24px;
				color: #ccc;
				text-align: center;
				line-height: 100px;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/common/components/error.vue